// src/router/configuracoes.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['admin']

const configuracoesBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Configurações',
        to: 'ConfiguracoesEdit'
    }
]

export default [

    {
        path: '/configuracoes',
        name: 'ConfiguracoesEdit',
        component: () => import('@/views/Configuracoes/NovaConfiguracaoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Configuração',
            breadcrumb: [
                ...configuracoesBreadCrumb,
                {
                    label: 'Detalhes da Configuração',
                    to: 'ConfiguracoesEdit'
                }
            ]
        }
    }

];
